import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDashboardAllRequests,
  fetchDashboardPendingRequests,
} from "../actions/dashboardActions";

const initialState = {
  allRequests: [],
  pendingRequests: [],
  isLoadingAll: false,
  isLoadingPending: false,
  errorAll: null,
  errorPending: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    clearDashboardErrors(state) {
      state.errorAll = null;
      state.errorPending = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch all requests
      .addCase(fetchDashboardAllRequests.pending, (state) => {
        state.isLoadingAll = true;
        state.errorAll = null;
      })
      .addCase(fetchDashboardAllRequests.fulfilled, (state, action) => {
        state.isLoadingAll = false;
        state.allRequests = Array.isArray(action.payload)
          ? action.payload.map((request) => ({
            ...request,
            requestType:
              request.requestType === "Executive Request"
                ? "Executive"
                : request.requestType,
          }))
          : [];
      })
      .addCase(fetchDashboardAllRequests.rejected, (state, action) => {
        state.isLoadingAll = false;
        state.allRequests = []; // Ensure empty array on error
        state.errorAll = action.payload;
      })
      // Fetch pending requests
      .addCase(fetchDashboardPendingRequests.pending, (state) => {
        state.isLoadingPending = true;
        state.errorPending = null;
      })
      .addCase(fetchDashboardPendingRequests.fulfilled, (state, action) => {
        state.isLoadingPending = false;
        state.pendingRequests = Array.isArray(action.payload)
          ? action.payload.map((request) => ({
            ...request,
            requestType:
              request.requestType === "Executive Request"
                ? "Executive"
                : request.requestType,
          }))
          : [];
      })
      .addCase(fetchDashboardPendingRequests.rejected, (state, action) => {
        state.isLoadingPending = false;
        state.pendingRequests = []; // Ensure empty array on error
        state.errorPending = action.payload;
      });
  },
});

export const { clearDashboardErrors } = dashboardSlice.actions;
export default dashboardSlice.reducer;
